// @seventide/types — platform area: home (spec §11 Home). Re-exported by ../platform.ts.
import { z } from 'zod';
import { IsoDateTime } from '../common';
import { DocumentCategory } from '../enums';

/** Keys of the new-workspace setup checklist shown on Home. */
export const HOME_SETUP_STEPS = [
  'consent',
  'legal_instrument',
  'invite_family',
  'add_account',
  'add_document',
  'first_record',
] as const;
export const HomeSetupStepKey = z.enum(HOME_SETUP_STEPS);
export type HomeSetupStepKey = z.infer<typeof HomeSetupStepKey>;

export const HomeSetupStep = z.object({
  key: HomeSetupStepKey,
  done: z.boolean(),
});
export type HomeSetupStep = z.infer<typeof HomeSetupStep>;

/** GET /api/w/:id/platform/home — figures for the Home screen that no single module owns. */
export const HomeOverview = z.object({
  /** Setup checklist (only steps relevant to this member's role and the enabled modules). */
  setup: z.object({
    steps: z.array(HomeSetupStep),
    completed: z.number().int(),
    total: z.number().int(),
    /** True when every step is done, or the workspace is older than 60 days (checklist hidden). */
    dismissed: z.boolean(),
  }),
  /** Key-documents checklist for the current stage (FR-2.4). `available=false` when documents are hidden. */
  keyDocuments: z.object({
    available: z.boolean(),
    missingCount: z.number().int(),
    totalCount: z.number().int(),
    missingCategories: z.array(DocumentCategory),
  }),
  memberCount: z.number().int(),
  /** Estate stage: when an executor pack was last generated (null when none yet). */
  executorPack: z.object({ lastGeneratedAt: IsoDateTime.nullable(), packCount: z.number().int() }).nullable(),
});
export type HomeOverview = z.infer<typeof HomeOverview>;
